import { basicInitialState } from '../_utils/basicInitialState';
import { TUserEditorState } from './userEditorModel';

export const userEditorInitialState: TUserEditorState = {
  ...basicInitialState,
  password: null,
  providers: null,
  user: null
};
